// import axios from "axios";
import { BACKEND_API_ENDPOINT } from '../../constants/default';
import axios from "axios/index";

// const headers = {};

export const getVendors = ({ query }) => {
  // const authHeader = {};

  // console.log("getVendors...");
  return axios.get(
    `${BACKEND_API_ENDPOINT}/search?${query}`,
    // {headers: {...headers, ...authHeader}}
  )
    .then(response => {
      // console.log("gotVendors.");
      return response.data;
    })
    .catch(error => {
      console.log('getVendors error', error);
      return {success: false, error};
    });
};
